import React, { useContext, useEffect } from "react";
import { AuthState } from '@aws-amplify/ui-components';
import { Route, useLocation, Redirect } from 'react-router-dom'
import { UserContext } from '../../UserContext'
import AuthGroupWrapper from './AuthGroupWrapper'

const PrivateRoute = (props) => {
  const location = useLocation();
  const { authState, activeUser } = useContext(UserContext)
  // console.log(location.pathname)
  if (authState === AuthState.SignedIn && activeUser) {
    return <Route {...props} />
  } else {
    // console.log("Redirecting")
    return <Redirect to={{ pathname: "/login", state: { from: location } }} />
  }

};
export default PrivateRoute;

// This is if someone is not logged in it takes them to the login page...
